import React from 'react';
import { Col, Row } from 'reactstrap';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import { ReactComponent as IcnDocument } from '../../images/icn_document.svg';
import {
  BtnRadiusWhite,
  ContFlexLeft,
  H4Styled,
  H5Styled,
  SecondaryBtnModalTable,
} from '../../styled-components';
import { ReactComponent as IconBack } from '../../images/icn-back.svg';
import variables from '../../variables';
import { useTranslation } from 'react-i18next';
import AgreementDetailTable from './AgreementDetailTable';
import Footer from '../../commons/Footer';
import AgreementAttachmentsTable from './AgreementAttachmentsTable';
import { Link } from 'react-router-dom';

const AgreementDetailsPresentational = ({
  data,
  total,
  offset,
  limit,
  onFilter,
  query,
  handleFileSigned,
  handleFileListView,
}) => {
  const [t] = useTranslation('AGREEMENTS');

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:AGREEMENTS')}
            icon={<IcnDocument fill="#ffffff" style={{ height: '25px' }} />}
          />
        </section>

        <Row style={{ marginBottom: '10px' }}>
          <Col sm="12" md="6">
            <ContFlexLeft>
              <Link to={`/agreements-admin`}>
                <BtnRadiusWhite>
                  <IconBack fill={variables.primary} />
                </BtnRadiusWhite>
              </Link>
              <H4Styled>{t('TITLE_DETAIL')}</H4Styled>
            </ContFlexLeft>
          </Col>
        </Row>

        <Row style={{ marginBottom: '10px' }}>
          <Col
            sm="12"
            md="3"
            style={{
              color: `${variables.primary}`,
              fontSize: '25px',
              fontWeight: 'bold',
            }}
          >
            {data.name}
          </Col>
        </Row>

        <Row style={{ justifyContent: 'end' }}>
          <Col sm="12" md="3">
            <SecondaryBtnModalTable
              type="button"
              style={{
                width: '100%',
                fontSize: '15px',
                padding: '6px 8px',
                cursor:
                  data.status === 'REQUESTED' || data.status === 'SIGNED'
                    ? 'pointer'
                    : 'not-allowed',
                opacity:
                  data.status === 'REQUESTED' || data.status === 'SIGNED'
                    ? 1
                    : 0.5,
              }}
              onClick={(event) => {
                if (data.status !== 'REQUESTED' && data.status !== 'SIGNED') {
                  return;
                }
                event.stopPropagation();
                handleFileSigned(data.signingRequestId);
              }}
            >
              {t('DOWNLOAD')}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-box-arrow-down"
                viewBox="0 0 16 16"
                style={{ margin: '0', marginLeft: '3px' }}
              >
                <path
                  fill-rule="evenodd"
                  d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1z"
                />
                <path
                  fill-rule="evenodd"
                  d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"
                />
              </svg>
            </SecondaryBtnModalTable>
          </Col>
        </Row>

        <section style={{ marginTop: '25px' }}>
          <Row style={{ marginBottom: '1rem' }}>
            <Col>
              <H5Styled>Contratto</H5Styled>
            </Col>
          </Row>
          <AgreementDetailTable
            data={[data]}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
          />
        </section>

        <section style={{ marginTop: '25px' }}>
          <Row style={{ marginBottom: '1rem' }}>
            <Col>
              <H5Styled>
                Lista documenti e schede che compongono il contratto
              </H5Styled>
            </Col>
          </Row>
          <AgreementAttachmentsTable
            data={data?.attachments}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            handleFileListView={handleFileListView}
          />
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default AgreementDetailsPresentational;
